import React, { useEffect, useState } from "react";

import { formTypes } from "../../constants";
import BaseModal from "../../shared/components/modals/BaseModal";

import LoginForm from "../auth-forms/LoginForm";
import ForgotForm from "../auth-forms/ForgotForm";
import SignupForm from "../agent-signup/SignupForm";
import RegisterForm from "../auth-forms/register-survey/RegisterForm";

const { TYPE_LOGIN, TYPE_FORGOT, TYPE_REGISTER, TYPE_AGENT_SIGNUP } = formTypes;

const AuthModal = ({ show, onClose, dismissible = true }) => {
  const [formType, setFormType] = useState(TYPE_LOGIN);

  useEffect(() => {
    if (show) {
      setFormType(TYPE_LOGIN);
    }
  }, [show]);

  const closeModal = () => {
    if (!dismissible && formType === TYPE_LOGIN) {
      return;
    }
    setFormType(TYPE_LOGIN);
    onClose?.();
  };

  const changeFormType = (type) => {
    setFormType(type);
  };

  return (
    <>
      {formType === TYPE_AGENT_SIGNUP && (
        <SignupForm
          show={show}
          onClose={closeModal}
          closeModal={closeModal}
          changeFormType={changeFormType}
        />
      )}
      {formType !== TYPE_AGENT_SIGNUP && (
        <BaseModal
          show={show}
          onClose={closeModal}
          showClose={dismissible || formType !== TYPE_LOGIN}
          size={
            formType === TYPE_LOGIN || formType === TYPE_REGISTER ? "xl" : "xs"
          }
          changeFormType={changeFormType}
          backDropClass={`${formType === TYPE_LOGIN ? "login-modal" : ""} ${
            formType === TYPE_FORGOT ? "login-modal-backdrop" : ""
          } ${formType === TYPE_REGISTER ? "register-survey-backdrop" : ""}`}
          dialogClassName={`${formType === TYPE_LOGIN ? "login-dialog" : ""} ${
            formType === TYPE_LOGIN || formType === TYPE_FORGOT
              ? "login-modal-dialog"
              : ""
          } ${formType === TYPE_REGISTER ? "register-survey-modal" : ""}`}
        >
          {formType === TYPE_LOGIN && (
            <LoginForm
              changeFormType={changeFormType}
              closeModal={closeModal}
            />
          )}
          {formType === TYPE_FORGOT && (
            <ForgotForm changeFormType={changeFormType} />
          )}
          {formType === TYPE_REGISTER && (
            <RegisterForm
              closeModal={closeModal}
              changeFormType={changeFormType}
            />
          )}
        </BaseModal>
      )}
    </>
  );
};

export default AuthModal;
